export const IS_LOGGED_IN = window.passportInfo.isLoggedIn;
// The opaque per-account key (encrypted account id) for namespacing client storage; null when logged out.
// A logged-in user ALWAYS has one: the server (views.py) fails the page (403) if it can't derive the key,
// so there is no logged-in-without-key state to defend against on the client.
export const ACCOUNT_KEY = window.passportInfo.accountKey ?? null;
/**
 * Namespace a storage key by the current ACCOUNT KEY so each account's data is isolated (account B can't
 * read account A's resume draft — UNIV-3404). When logged out (no account key) the base key is used
 * unchanged: the form is login-gated, so any write while logged out is empty scaffolding, not user data.
 */
export function namespacedStorageKey(baseKey) {
    return ACCOUNT_KEY ? `${baseKey}::${ACCOUNT_KEY}` : baseKey;
}
export function getPassportURL(action, fromComponent, nextPath) {
    const query = {
        next: nextPath ? `/form/#${nextPath}` : `/form/${window.location.hash}`,
        from: `universal-resume-${fromComponent}-${action}`,
        hl: 'ja',
        co: 'JP'
    };
    const queryStr = Object.keys(query)
        .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(query[k])}`)
        .join('&');
    switch (action) {
        case 'signup':
            return `${window.passportInfo.signupURL}?${queryStr}`;
        case 'login':
            return `${window.passportInfo.loginURL}?${queryStr}`;
        case 'logout':
            return `${window.passportInfo.logoutURL}?${queryStr}`;
        case 'view':
            return `${window.passportInfo.viewURL}?${queryStr}`;
        default:
            throw new Error(`Unsupported passport action: ${action}`);
    }
}
